/**
 * @generated SignedSource<<cd889c8c0a2191fcb7f63a5a5619ee50>>
 * @relayHash cf345a5c59070a4a68c6cc26bd829aac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 860accf0fa726bd52672898704578be03657729950e8fa7a5d2e9d74f0a83976

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "860accf0fa726bd52672898704578be03657729950e8fa7a5d2e9d74f0a83976",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
